<template>
  <order-body
    :isOk="true"
    :isPage="true"
    :codeStatus="200"
    @print="print"
    :pageText="'orderConfirm'"
  ></order-body>
</template>

<script>
import { postPdf } from "@/api/order/list";
import orderBody from "_my/order-body";

export default {
  name: "orderConfirm",
  components: {
    orderBody
  },
  methods: {
    print(data) {
      postPdf(data).then(res => {
        if (res.data.status) {
          window.open(this.$globalUrl + res.data.data[0].url, "_blank");
        } else {
          this.$Message["error"]({
            background: true,
            content: res.data.msg
          });
        }
      });
    }
  }
};
</script>
